module.exports = __webpack_public_path__ + "img/reward.17bfd226.svg";